/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import Input from '@cashew/input';
import { useEnterListener } from '@cashew/hooks';
import './index.css';
import SelectComponent from '../../components/SelectComponent';

const { api } = require('@cashew/utils');

export default ({
  setLoading,
  useSelector,
  setRecords,
  setList,
  pageSize,
  pageNumber,

  setPageNumber,
}: any) => {
  const { token, selectedStore } = useSelector((state: any) => state.user);
  const [searchId, setSearchId] = useState('');
  const [searchBy, setSearchBy] = useState<string>('mobileNumber');
  const [enterBtn, setEnterBtn] = useState(false);

  const searchByData = [
    {
      key: 'firstName',
      value: 'First name',
    },
    {
      key: 'lastName',
      value: 'Last name',
    },
    {
      key: 'mobileNumber',
      value: 'Phone number',
    },
    {
      key: 'email',
      value: 'Email',
    },
    {
      key: 'idNumber',
      value: 'National ID',
    },
  ];

  const getCustomersApi = (resetPageNumber = true) => {
    if (resetPageNumber && pageNumber !== 0) {
      setPageNumber(0);
      return;
    }
    setLoading(true);

    const params: any = {
      page: pageNumber,
      size: pageSize,
      [searchBy]: searchId,
    };

    api
      .get({
        endpoint: 'customers/profile/all',
        params,
        headers: {
          Authorization: token,
        },
      })
      .then((resp: any) => {
        setLoading(false);
        setRecords(resp.totalCount);
        const { data } = resp;
        setList(data);
      })
      // eslint-disable-next-line no-console
      .catch((error: any) => console.log(error));
  };

  useEffect(() => {
    getCustomersApi();
  }, [selectedStore]);

  useEffect(() => {
    setSearchId('');
  }, [searchBy]);

  useEnterListener(() => setEnterBtn((prev) => !prev));

  useEffect(() => {
    getCustomersApi(false);
  }, [pageNumber, pageSize, enterBtn]);

  return (
    <div className="filters">
      <div className="filter-group">
        <div className="filter-input">
          <SelectComponent
            label="Search by"
            data={searchByData}
            selected={searchBy}
            onSelect={setSearchBy}
          />
        </div>
        <div className="filter-input">
          <Input
            name="orderId"
            value={searchId}
            maxLength={searchBy === 'orderId' ? 14 : 100}
            type="text"
            onChange={(e: any) => {
              setSearchId(e.target.value.trim());
            }}
          />
        </div>
        <div className="filter-input">
          <button
            type="button"
            className="btn blue"
            onClick={() => {
              getCustomersApi();
            }}
          >
            Search
          </button>
        </div>
      </div>
    </div>
  );
};
